import React from "react";
import ImageWithRect from "./ImageWithRect";
import { APIEND_POINT } from "../../Api";

const ImgSlider = ({ imgList, slideIndex, show }) => {
  return (
    <div className="relative w-full overflow-hidden">
      <div
        className="flex transition-transform duration-500"
        style={{ transform: `translateX(-${slideIndex * 100}%)` }}
      >
        {imgList?.map((item, index) => {
          return (
            <div key={index} className="w-full flex-shrink-0 h-[65vh] lgLp:h-[65vh] flex-grow select-none">
              <ImageWithRect
                show={show}
                data={{
                  img: APIEND_POINT + item.image,
                  label: item?.ai_app_extracted_data?.license_plate,
                  ...item.ai_app_extracted_data,
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImgSlider;
